import axios from "axios";
import { Navigate } from "react-router-dom";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export async function logindata(data) {
  try {
    return await axios
      .post(`${baseUrl}/login`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function logoutdata() {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/logout`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function forgotpassword(data) {
  try {
    return await axios
      .get(`${baseUrl}/forgot-username?username=${data}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getlocation() {
  try {
    return await axios
      .get(`https://geolocation-db.com/json/`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (error) {
    console.log(error);
  }
}

export async function trackingdata(data) {
  try {
   
    return await axios
      .post(`${baseUrl}/saveactivelog`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function bannertrackingdata(data) {
  try {
   
    return await axios
      .post(`${baseUrl}/banners-tracking`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function multichangepassword(data) {
  try {
    return await axios
      .post(`${baseUrl}/changepasswords`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


function catcherror(error) {
  console.log(error.response);

  if (!error.response) {
    if (error.request) {
      toast.error("Unable to reach the server. Please check your internet connection.");
    } else {
      toast.error(error.message || "Something went wrong. Please try again.");
    }
    return;
  }

  const status = error.response.status;
  const data = error.response.data;

  if (status === 401) {
    localStorage.clear();
    <Navigate to={"/login"} />;
  } else if (status === 422) {
    Swal.fire({
      title: "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  } else if (status === 0) {
    toast.error(error.message);
  } else if (status === 500) {
    toast.error(error.response.statusText);
  } else if (
    status !== 200 &&
    data && data.status === false &&
    data.code !== 200
  ) {
    toast.error(data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
